export enum CustomDataAttributeType {
    Text = 'input',
    Checkbox= 'checkbox',
    TextArea = 'textarea',
    Options = 'radio',
    Select = 'select',
    // MultiSelect = 'tagsinput',
    DatePicker = 'datepicker',
  }
    